import { cn } from "@/lib/utils";

interface SpinnerProps {
	className?: string;
	size?: number;
	color?: string;
}

const bars = Array.from({ length: 12 }, (_, i) => i);

const Spinner = ({
	size = 20,
	className,
	color = "currentColor",
}: SpinnerProps) => {
	return (
		<div
			className={cn("wrapper", className)}
			style={
				{
					"--spinner-size": `${size}px`,
					"--spinner-color": color,
				} as React.CSSProperties
			}
		>
			<div className="spinner">
				{bars.map((i) => (
					<div className="bar" key={`spinner-bar-${i}`} />
				))}
			</div>
		</div>
	);
};

export { Spinner };
